// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__364It","content":"LayoutSettings_content__4k6XC"};